var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.72335 5.59835C2.625 6.6967 2.625 8.46447 2.625 12C2.625 15.5355 2.625 17.3033 3.72335 18.4017C4.8217 19.5 6.58947 19.5 10.125 19.5H13.875C17.4105 19.5 19.1783 19.5 20.2766 18.4017C21.375 17.3033 21.375 15.5355 21.375 12C21.375 8.46447 21.375 6.6967 20.2766 5.59835C19.1783 4.5 17.4105 4.5 13.875 4.5H10.125C6.58947 4.5 4.8217 4.5 3.72335 5.59835ZM18.1652 7.79987C18.4138 8.09819 18.3734 8.54156 18.0751 8.79016L16.0159 10.5062C15.185 11.1986 14.5115 11.7599 13.917 12.1422C13.2978 12.5405 12.6948 12.7921 12 12.7921C11.3052 12.7921 10.7022 12.5405 10.083 12.1422C9.48855 11.7599 8.81504 11.1987 7.98408 10.5062L5.92487 8.79016C5.62655 8.54156 5.58624 8.09819 5.83484 7.79987C6.08344 7.50155 6.52681 7.46124 6.82513 7.70984L8.84909 9.39648C9.72374 10.1254 10.331 10.6298 10.8437 10.9595C11.3399 11.2787 11.6765 11.3858 12 11.3858C12.3235 11.3858 12.6601 11.2787 13.1563 10.9595C13.669 10.6298 14.2763 10.1254 15.1509 9.39648L17.1749 7.70984C17.4732 7.46124 17.9166 7.50155 18.1652 7.79987Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/Mail.41febde8450b958522e48f3129e3e8ea.svg";
export { ForwardRef as ReactComponent };